import React, { useEffect, useState } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsRemaining,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const ShippedStatus = ({ query = "", userPermission }) => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // Состояния для пагинации
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  // Функция загрузки данных
  const loadData = async (page = 1, pageSize = 20) => {
    try {
      setIsLoading(true);
      // Для "Отгружено" загружаем соответствующие статусы без фильтра remaining
      const res = await fetchStatuses(
        ["ACTIVE", "COMPLETED"], // Может быть в любом из этих state
        ["ON_DELIVERY", "ORDER_DELIVERED"], // Отгружено или доставлено
        query,
        setOrders,
        setIsLoading,
        setTotalCount,
        pageSize,
        page,
        false // не remaining
      );

      setCurrentPage(res.data?.currentPage || page);
      setLimit(pageSize);
      setTotalCount(res.data?.totalCount || 0);
    } catch (err) {
      console.error("Error fetching ShippedStatus:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData(1, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
    loadData(page, pageSize);
  };

  return (
    <div>
      <Table
        size="small"
        bordered
        loading={isLoading}
        dataSource={getOrderStatusDataSource(orders)}
        columns={orderStatusColumnsRemaining}
        pagination={false}
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
            />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          onChange={handlePageChange}
          showSizeChanger
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default ShippedStatus;
